<template>
  <app-overlay-loader v-if="preloader"/>
  <form v-else @submit.prevent="submitData" ref="form" :data-url="apiUrl.TENANT_INDUSTRY_SETTINGS">


    <div class="row">
      <div class="col-md-12">
        <app-form-group
            :custom-input="true"
            :label="$t('Industry Type')"
            v-model="formData.industry_types"
            :data="{ id: 'industry_types' }"
        />
<!--        <div class="input-area">
          <div class="d-flex flex-column">
            <label id="industry_types" for="industry_types">{{ $t('Industry Type') }}</label>
          </div>
          <app-custom-tag-input id="industry_types" :placeholder="'Add Industry Type'" name="industry_types" @update-tags="(tags) => handleTagsUpdate(tags, 'industry')" :tags="formData.industry_types" />
        </div>-->
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-12">
        <app-form-group
            :custom-input="true"
            :label="$t('Add Company Size')"
            v-model="formData.company_size"
            :data="{ id: 'company_size' }"
        />
<!--        <div class="input-area">
          <div class="d-flex flex-column">
            <label id="company_size" for="company_size">{{ $t('Company Size') }}</label>
          </div>
          <app-custom-tag-input :data="{ id: 'company_size' }" :placeholder="'Add Company Size'" @update-tags="(tags) => handleTagsUpdate(tags, 'size')" :tags="formData.company_size" />
        </div>-->
      </div>
    </div>


    <div class="row mt-4">
      <div class="col-3"></div>
      <div class="col-9">
        <app-submit-button :label="$t('save')" :loading="loading" @click="submitData"/>
      </div>
    </div>
  </form>
</template>

<script>
import FormHelperMixins from "../../../../../common/Mixin/Global/FormHelperMixins";
import {axiosGet} from "../../../../../common/Helper/AxiosHelper";
import {InputMixin} from "../../../../../core/components/input/mixin/InputMixin";
import VueTagsInput from '@johmun/vue-tags-input';
import _ from "lodash";
import {kebabCase} from "../../../../../common/Helper/Support/TextHelper";

export default {
  name: "TenantIndustrySetting",
  mixins: [FormHelperMixins, InputMixin],
  components: {
    VueTagsInput
  },
  data() {
    return {
      company_size: [],
      industry_types: [],
      formData: {
        company_size: [],
        industry_types: [],
      },
    }
  },
  methods: {
    afterSuccess(response) {
      this.toastAndReload(response.data.message)
    },
    handleTagsUpdate(tags, name='size') {
      if (name === 'size') {
        this.company_size = tags;
        this.formData.company_size = tags;
      } else {
        this.industry_types = tags;
        this.formData.industry_types = tags;
      }
    },
    getSetting() {
      this.preloader = true;
      axiosGet(this.apiUrl.TENANT_INDUSTRY_SETTINGS).then(({data}) => {
        this.formData = {
          company_size: data.company_size ?JSON.parse(data.company_size) : [],
          industry_types: data.industry_types ? JSON.parse(data.industry_types) : [],
        }
      }).finally(() => {
        this.preloader = false;
      })
    },
    addIndustry() {
      // this.formData.industry_types.push('');
      this.formData.company_size.push({
        size: ''
      });
    },
    propsFor() {
      let props = this.$attrs;
      const cTor = this.$options.components['app-input']
      if (cTor) {
        let keys = Object.keys(cTor.options.props)
        return _.pick(props, keys.map(key => {
          return kebabCase(key)
        }))
      }
    },
    removeIndustry(index) {
      // this.formData.features.splice(index, 1);
      this.formData.company_size.splice(index, 1);
    },
  },
  mounted() {
    this.getSetting();
  },
  watch: {}
}
</script>